import { render } from "./EasyFooter.vue?vue&type=template&id=5a48990d&scoped=true"
const script = {}

import "./EasyFooter.vue?vue&type=style&index=0&id=5a48990d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a48990d"]])

export default __exports__